let logoutTriggered = false;

export const authEvents = {
  triggerLogoutOnce(callback) {
    if (logoutTriggered) {
      return;
    }

    logoutTriggered = true;
    callback();
  },

  reset() {
    logoutTriggered = false;
  },
};
